const color = {
    primary: {
        base: "#36501c",
        light: "#60804f",
        xlight: "#90b361",
        xxlight: "#a7bf86",
        xxxlight: "#c9e0ad"
    },
    secondary: {
        xxlight: "#ebf4f3",
    },
    neutral: {
        base: "#333333",
        xlight: "#CFCFCF",
        xxxlight: "#FFF",
    },
    error: {
        base: "#FF0000",
        xlight: "#FF9999",
        xxlight: "#FFD6D6",
    },
    warning: {
        base: "#FFCD11",
        xlight: "#FFE999",
        xxlight: "#FFF6D6",
    },
    ok: {
        base: "#62C370",
        xlight: "#B5E3BC",
    },
    status: {
        base: "#E2E8F3",
        scheduledDraft: "#FDE3D8",
        started: "#A7B9DC",
        completed: "#E1F4E4",
        invoiced: "#62C370",
    },
};

const font = {
    h1: {
        "font-family": "Staatliches, sans-serif",
        "font-style": "normal",
        "font-weight": "normal",
        "font-size": "24px",
        "line-height": "150%",
        "text-transform": "uppercase",
    },
    h2: {
        "font-family": "Open Sans, sans-serif",
        "font-style": "normal",
        "font-weight": "600",
        "font-size": "20px",
        "line-height": "150%",
    },
    t: {
        "font-family": "Open Sans, sans-serif",
        "font-style": "normal",
        "font-weight": "normal",
        "font-size": "16px",
        "line-height": "150%",
    },
    tb: {
        "font-family": "Open Sans, sans-serif",
        "font-style": "normal",
        "font-weight": "600",
        "font-size": "16px",
        "line-height": "150%",
    },
    s: {
        "font-family": "Open Sans, sans-serif",
        "font-style": "normal",
        "font-weight": "normal",
        "font-size": "14px",
        "line-height": "150%",
    },
};

export const device = {
    mobile: `(min-width: 0px) and (max-width: 767px)`,
    tablet: `(min-width: 768px) and (max-width: 1223px)`,
    desktop: `(min-width: 1224px)`,
    m2t: `(min-width: 0px) and (max-width: 1223px)`,
    t2d: `(min-width: 768px)`,
};

export default {
    breakpoints: {
        m: 0,
        p: 768,
        d: 992,
    },
    spacing: {
        0: "0",
        1: "0.25rem",
        2: "0.5rem",
        3: "1rem",
        4: "1.5rem",
        5: "3rem",
    },
    font: font,
    color: color,
    button: {
        padding_y: "11px",
        padding_x: "20px",
    },
    input: {
        padding: "14px",
    },
    header: {
        height: "70px",
        background: {
            color: color.primary.xlight,
        },
    },
    text: {
        color: {
            main: color.neutral.base,
            second: color.neutral.xxxlight,
            link: color.primary.base,
        },
    },
    footer: {
        height: "60px",
        background: {
            color: color.secondary.base,
        },
        text: {
            color: color.neutral.xxxlight,
        },
    },
    scheduler: {
        dayWidth: 800, // Width for whole day, including off hours and breaks
        nonWorkingHoursWidth: 100, // Width of one segment displaying off hours
        workingHoursWidth: 800 - 100 * 2, // dayWidth - (nonWorkingHoursWidth * 2)
        cellHeight: 40,
        leftWidth: 200,
        rightWidth: 115,
        taskWidth: 108,
        borderWidth: 2,
    },
};
